import React from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import axios from 'axios';


class AdminUserList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            users: []
        }
    }

    componentDidMount(){
        axios.get(`/api/users`)
            .then((response) => {
                let users = response.data;
                let orderedUsers = users.sort(function(a, b){
                    let userA = a.firstName.toUpperCase(),
                        userB = b.firstName.toUpperCase();
                    return (userA < userB) ? -1 : (userA > userB) ? 1 : 0;
                });

                this.setState({users: orderedUsers})
            });
    }

    render(){
        const columns = [ {
            id: 'name',
            Header: 'Name',
            accessor: u => {
                return `${u.firstName} ${u.lastName}`;
            }
        }, {
            Header: 'Email',
            accessor: 'email'
        }, {
            Header: 'Credits',
            accessor: 'credits'
        }, {
            id: 'editCredits',
            Header: 'Edit Credits',
            accessor: u => <Link to={`/admin/edit-user/${u.id}?credits=${u.credits}`}>Edit</Link>
        }]


        return (
            <div className="mb3">
                <ReactTable
                    data={this.state.users}
                    columns={columns}
                    defaultPageSize={10}
                />
            </div>
        );
    }
}

export default AdminUserList;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/AdminUserList.js